import { useSEO } from '@/context/seoContext'
import { Helmet } from 'react-helmet-async'
import defaultOgImage from '@/assets/images/neverbe.jpg'
import { useEffect } from 'react'

type SEOProps = {
  title?: string
  description?: string
  canonicalUrl?: string
  noIndex?: boolean
}

type SEOSettings = {
  title?: string
  description?: string
  canonicalUrl?: string
  ogImage?: string
}

export const SEO = ({
  title,
  description,
  canonicalUrl,
  noIndex = false,
}: SEOProps) => {
  const { seoSettings }: { seoSettings: SEOSettings } = useSEO()

  const finalTitle = title || seoSettings.title || '꿀프'
  const finalDescription =
    description ||
    seoSettings.description ||
    '꿀프에서 골프 관련 서비스를 확인하세요.'
  const finalCanonicalUrl =
    canonicalUrl || seoSettings.canonicalUrl || 'https://ggoollff.co.kr'

  // 네이버 봇을 위한 직접적인 title 설정
  useEffect(() => {
    document.title = finalTitle
  }, [finalTitle])

  return (
    <Helmet>
      <meta charSet="utf-8" />
      {/* <title>{title || seoSettings.title}</title>
      <meta
        name="description"
        content={
          description ||
          seoSettings.description ||
          '꿀프에서 골프 관련 서비스를 확인하세요.'
        }
      />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link
        rel="canonical"
        href={
          canonicalUrl || seoSettings.canonicalUrl || 'https://ggoollff.co.kr'
        }
      />

      <meta property="og:title" content={title || seoSettings.title} />
      <meta
        property="og:description"
        content={
          description ||
          seoSettings.description ||
          '꿀프에서 골프 관련 서비스를 확인하세요.'
        }
      />
      <meta
        property="og:url"
        content={
          canonicalUrl || seoSettings.canonicalUrl || 'https://ggoollff.co.kr'
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content={seoSettings.ogImage || defaultOgImage}
      /> */}

      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="canonical" href={finalCanonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={finalCanonicalUrl} />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content={seoSettings.ogImage || defaultOgImage}
      />

      {/* 네이버 전용 메타 태그 */}
      <meta
        name="naver-site-verification"
        content="7589904bb69c4b69fa7c4057a3f12a8dbbde2592"
      />
      {/* 구글 전용 메타 태그 */}
      <meta
        name="google-site-verification"
        content="Df8HlvIKcGlj5Z30M4vBLctT9WUn9_cqn6jtfiKW17M"
      />
    </Helmet>
  )
}
